import { css } from '@emotion/react';
import { math } from 'polished';
import { BorderRadius } from './mixins/_border-radius.mixin';
import { AlertVariant } from './mixins/_alert.mixin';
import { themeColorLevel } from './_functions';

export default $ => {
  return css`
    .alert {
      position: relative;
      padding: ${$.alertPaddingY} ${$.alertPaddingX};
      margin-bottom: ${$.alertMarginBottom};
      border: ${$.alertBorderWidth} solid transparent;
      ${new BorderRadius($.alertBorderRadius).include($)};
    }

    .alert-heading {
      color: inherit;
    }

    .alert-link {
      font-weight: ${$.alertLinkFontWeight};
    }

    .alert-dismissible {
      padding-right: ${math(`${$.closeFontSize} + ${$.alertPaddingX} * 2`)};

      .close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        padding: ${$.alertPaddingY} ${$.alertPaddingX};
        color: inherit;
      }
    }

    ${css(
      Object.keys($.themeColors).map(color => css`
        .alert-${color} {
          ${new AlertVariant(
            themeColorLevel($, color, $.alertBgLevel),
            themeColorLevel($, color, $.alertBorderLevel),
            themeColorLevel($, color, $.alertColorLevel)
          ).include($)}
        }
      `
      )
    )}
  `;
};
